import type { HttpGet } from '@/shared/infra/http'
import type { HuntConstraints, LoadEffectiveHuntConstraints } from '@/shared/domain'

export class EdgeLoadEffectiveHuntConstraintsRepository {
  constructor(private readonly httpClient: HttpGet) {}

  execute: LoadEffectiveHuntConstraints = async (params) => {
    const locationQuery =
      params.locationType === undefined || params.locationId === undefined
        ? ''
        : `&locationType=${params.locationType}&locationId=${params.locationId}`
    const query = `?orgId=${params.orgId}&orgType=${params.orgType}${locationQuery}`
    return this.httpClient.get<HuntConstraints>({
      url: `/org-settings/hunt-constraints/effective${query}`,
    })
  }
}
